export { WECHAT_WEBVIEW_LOGIN, LOGIN_PAGE_URL } from '../../../config';
export var RELOAD_MINI_PROGRAM_DESKTOP_URL = '/pages/list/list?reason=pskey_error';
